module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "none"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rolesOptions,
      "item-text": "name",
      "item-value": "value",
      "hide-details": "auto",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.updateUserRole(val); }
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d724d1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/inputs/AgGridRoleSelect.vue
// module id = 1872
// module chunks = 0